import classNames from 'classnames';
import * as Logos from '@/assets/logos/logos';
import styles from './logo.module.scss';

export interface LogoProps {
  /** The class name to apply */
  className?: string;
  /** The name of the icon to show */
  name: LogoName;
  /** A title to show when hovering the icon */
  title?: string;
}

const Icon = ({ className, name, title }: LogoProps) => {
  const LogoComponent = Logos[name];

  if (!LogoComponent) {
    return null;
  }

  return (
    <div className={classNames(styles.component, className)} title={title}>
      <LogoComponent
        className={styles.logo}
        preserveAspectRatio="xMidYMid meet"
      />
    </div>
  );
};

Icon.displayName = 'Icon';

export default Icon;
